export enum EWidgetType {
  LineChart = 'lineChart',
  ComplexTable = 'complexTable'
}
